import React from "react"
import PropTypes from "prop-types"
import COLOR_PALETTE from "constants/color-palette"
import { Radium } from "higher-order-components"
import { BASE_HEADING } from "constants/general-style"
import { WysiwygContent } from "components"
import { Interactive, P, Content } from "AtomicComponents";

const MyMazdaPolicyDetail = props => {
  const {
    policyNumber, startDate, expiryDate, policyStatus, isExpired, contactBlurb
  } = props

  return (
    <div style={styles.wrapper}>
      {policyNumber && <MyMazdaPolicyDetailItem label="Policy number" description={policyNumber} />}
      {startDate && <MyMazdaPolicyDetailItem label="Start date" description={startDate} />}
      {expiryDate && <MyMazdaPolicyDetailItem label="Expiry date" description={expiryDate} />}
      {policyStatus && (
        <MyMazdaPolicyDetailItem
          label="Policy status"
          description={policyStatus}
          isExpired={isExpired} />
      )}
      {contactBlurb && (
        <MyMazdaPolicyDetailItem
          label="Contact"
          description={<Content textAlign="left" xmlString={contactBlurb} />} />
      )}
    </div>
  )
}

const MyMazdaPolicyDetailItem = Radium(({ label, description, isExpired }) => {
  return (
    <div key={label} style={{ textAlign: "left" }}>
      <Interactive>
        {label}
      </Interactive>
      <P>
        {description}
      </P>
    </div>
  )
})

const styles = {
  wrapper: {
    background: COLOR_PALETTE.WHITE,
    border: "1px solid " + COLOR_PALETTE.GRAY,
    padding: "2em 1.5em 0.5em"
  }
}

MyMazdaPolicyDetail.propTypes = {
  policyNumber: PropTypes.string,
  startDate: PropTypes.string,
  expiryDate: PropTypes.string,
  policyStatus: PropTypes.string,
  isExpired: PropTypes.bool,
  contactBlurb: PropTypes.string
}

export default Radium(MyMazdaPolicyDetail)



// WEBPACK FOOTER //
// ./src/blocks/mymazda/policies/detail.jsx